module.exports = __webpack_public_path__ + "assets/img/bp_d_i_2.f1ad7510.jpg";